import React, { useEffect } from 'react';
import { Switch, Route, useLocation } from 'react-router-dom';
// import { Col, Container, Row } from 'reactstrap';
import initIconLibrary from 'icons';
import toast, { Toaster } from 'react-hot-toast';

import AuthedUserRoute from 'containers/AuthedUserRoute';

import Header from 'components/Header';
import MainContainer from 'components/MainContainer';
import UpdateNotificationToast from 'components/UpdateNotificationToast';
import { Button } from 'reactstrap';

import MagicLinkLogin from 'components/MagicLinkLogin';
import * as styles from 'styles/index.scss';
import AppWrapperV2 from 'components/AppWrapperV2';
import LegalDisclaimer from 'components/LegalDisclaimer';
import PageScrollUp from '../../components/PageScrollUp';
import { page } from '../../lib/track';

const { addGreyBackground } = styles;

const Landing = React.lazy(() => import('routes/Landing'));
const ModalRouter = React.lazy(() => import('routes/Modal'));
const Checkout = React.lazy(() => import('routes/Checkout'));
const Orders = React.lazy(() => import('routes/Orders'));
const Profile = React.lazy(() => import('routes/User/Profile'));
const Products = React.lazy(() => import('routes/Products'));
const UserMerger = React.lazy(() => import('routes/User/Merge'));
const Dashboard = React.lazy(() => import('routes/User/Dashboard'));

initIconLibrary();

//Rudderstack page view event,  listens for changes in URL
const pageView = () => {
  const location = useLocation();
  React.useEffect(() => {
    page();
  }, [location]);
};
const App = () => {
  pageView();

  return (
    <div>
      <PageScrollUp />
      <React.Suspense fallback={null}>
        <Switch>
          {/* Public routes */}
          {/* <Route path="/test" component={WLCWrapper} /> */}
          <Route path="/about/" component={() => <div>About</div>} />
          <Route path="/blog/" component={() => <div>Blog</div>} />
          <Route exact path="/checkout/404" component={() => <div>404 Offer Not Found</div>} />
          <Route path="/checkout/" component={Checkout} />
          <Route path="/users/login/magic" component={MagicLinkLogin} />
          {/* Authorized users only - redirects to / if not logged in */}
          <AuthedUserRoute path="/orders/" component={AppWrapperV2(Orders)} />
          <AuthedUserRoute path="/products/" component={Products} />
          {/* userId -> you/public */}
          <AuthedUserRoute path="/profile/:userId" component={AppWrapperV2(Profile)} />
          {/* if no userId user == me */}
          <AuthedUserRoute path="/profile/" component={AppWrapperV2(Profile)} />
          <AuthedUserRoute path="/dashboard/" component={AppWrapperV2(Dashboard)} />
          <AuthedUserRoute path="/users/merges" component={AppWrapperV2(UserMerger)} />
          {/* Default */}
          <Route path="/users/password/:instruction" component={Landing} />
          <Route path="/" component={Landing} />
        </Switch>
        <ModalRouter />
      </React.Suspense>
      <Toaster />
      <LegalDisclaimer excludeMarginRoutes={['/checkout', /^\/products\/?$/]} />
    </div>
  );
};

export default App;
